module.exports = __webpack_public_path__ + "static/Averta-Regular-f4fe7de32fadfc5ac640d5c3dd0af557.eot";